export const SET_USER_INFO = 'setUserInfo';
export type SET_USER_INFO_TYPE = typeof SET_USER_INFO;

export const SET_ACCESS_TOKEN = 'accessToken';
export type SET_ACCESS_TOKEN_TYPE = typeof SET_ACCESS_TOKEN;

export const SET_OTHER_INFO = 'setOtherInfo';
export type SET_OTHER_INFO_TYPE = typeof SET_OTHER_INFO;